<template>
  <div class="container light-style flex-grow-1 container-p-y py-3">


    <div class="card overflow-hidden">
      <div class="row no-gutters row-bordered row-border-light">
        <div class="col-md-3 pt-0">
          <div class="list-group list-group-flush account-settings-links">
            <a class="list-group-item list-group-item-action active" data-toggle="list" href="#account-general" style="">General</a>
            <a class="list-group-item list-group-item-action" data-toggle="list" href="#account-change-password">Change password</a>
          </div>
        </div>
        <div class="col-md-9">
          <div class="tab-content">
            <div class="tab-pane fade active show" id="account-general">

              <div class="card-body media align-items-center">
                <b-icon-file-person-fill  font-scale="7.5" class="p-2"></b-icon-file-person-fill>

                <div class="card-body mt-3">
                    <p class="form-label">Username: <span style="color:#00948a; font-weight: bold;">{{this.username}}</span></p>
                    <p class="form-label">First Name: <span style="color:#00948a; font-weight: bold;">{{this.first_name}}</span></p>
                    <p class="form-label">Last Name: <span style="color:#00948a; font-weight: bold;">{{this.last_name}}</span></p>
                    <p class="form-label">E-mail:  <span style="color:#00948a; font-weight: bold;">{{this.email}}</span></p>
                   
                 <!-- <div  class="form-group">
                    <label class="form-label">Username: <span style="color:#00948a; font-weight: bold;">{{$store.getters.user[0].username}}</span></label>
                  
                    <input type="text" class="form-control mb-1" :placeholder="username" v-model="username_new" >
                  </div>
                  <div class="form-group">
                    <label class="form-label">E-mail:  <span style="color:#00948a; font-weight: bold;">{{$store.getters.user[0].email}}</span></label>
                   <input type="email" class="form-control mb-1" :placeholder="email" v-model="email_new">
                  </div>-->
                </div>

              </div>
              <!--<div class="text-right m-2">
                <button type="button" class="btn" style="background-color: #00948A; color: #fff;" @click="UpdateUser">Save changes</button>&nbsp;
              </div>
              <b-alert show variant="primary" class="alert text-center" v-if="successAlert"> Success!</b-alert>
              <b-alert show variant="danger" class="alert text-center" v-if="alert">Something went wrong try again!</b-alert>
-->
            </div>

            <div class="tab-pane fade" id="account-change-password">
              <div class="card-body p-3">

                <div class="form-group">
                  <label class="form-label">Current password:</label>
                  <input type="password" class="form-control" v-model="old_password">
                </div>

                <div class="form-group">
                  <label class="form-label">New password:</label>
                  <input type="password" class="form-control" v-model="password" aria-describedby="passwordHelp">
                  
                  <small v-if="has_minimum_lenth || has_number || has_lowercase || has_uppercase || has_special" id="passwordHelp" class="form-text text-muted" >
                    <li v-if="!has_minimum_lenth" class="red">Password must has at least 8 characters</li>
                    <li v-if="has_minimum_lenth" class="green">Password must has at least 8 characters</li>
                    <li v-if="!has_lowercase" class="red">Password must has at least 1 lowercase</li>
                    <li v-if="has_lowercase" class="green">Password must has at least 1 lowercase</li>
                    <li v-if="!has_uppercase" class="red">Password must has at least 1 uppercase</li>
                    <li v-if="has_uppercase" class="green">Password must has at least 1 uppercase</li>
                    <li v-if="!has_number" class="red">Password must has at least 1 digit</li>
                    <li v-if="has_number" class="green">Password must has at least 1 digit</li>
                    <li v-if="!has_special" class="red">Password must has at least 1 special character</li>
                    <li v-if="has_special" class="green">Password must has at least 1 special character</li>
                  </small>
                </div>

                <div class="form-group">
                  <label class="form-label">Repeat new password:</label>
                  <input type="password" class="form-control" v-model="password2">
                  <small v-if="has_minimum_lenth || has_number || has_lowercase || has_uppercase || has_special" id="passwor2dHelp" class="form-text text-muted" >
                    <li v-if="error" class="red">Password do not match</li>
                    
                  </small>
                </div>
                <div class="text-right mt-3">
                  <button type="button" class="btn" style="background-color: #00948A; color: #fff;" @click="ChangePassword">Save changes</button>&nbsp;
                </div>
                <b-alert show variant="primary" class="alert text-center" v-if="successAlert"> Success!</b-alert>
                <b-alert show variant="danger" class="alert text-center" v-if="alert">Something went wrong try again!</b-alert>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>



  </div>
</template>



<script>
//demo123!T
import axios from '../axios-auth'
export default {
  data(){
    return {
      old_password: '',
      password: null,
      password2: null,
      successAlert:false,
      alert: false,
      username_new: null,
      email_new:'',
      has_minimum_lenth: false,
      has_number: false,
      has_lowercase: false,
      has_uppercase: false,
      has_special: false,
      error:false,
      success:false
      
    }
  },
  watch:{
            password(){
              
                this.has_minimum_lenth = (this.password.length >= 8);
                this.has_number    = /\d/.test(this.password);
                this.has_lowercase = /[a-z]/.test(this.password);
                this.has_uppercase = /[A-Z]/.test(this.password);
                this.has_special   = /[!@#\$%\^\&*\)\(+=._-]/.test(this.password);
                this.success=this.has_minimum_lenth && this.has_number && this.has_lowercase && this.has_uppercase && this.has_special
                if(this.password!== this.password2 && this.password2!==null){
                this.error=true 
                }else{
              this.error=false
            }
               
            },
            password2(){
              if(this.password!== this.password2 && this.password!==null){
                this.error=true 
            }else{
              this.error=false
            }
        },
  },
  computed: {
    username () {
      // console.log(this.$store.getters.user)
      return !this.$store.getters.user ? false : this.$store.getters.user[0].username
    },
    email () {
      // console.log(this.$store.getters.user)
      return !this.$store.getters.user ? false : this.$store.getters.user[0].email
    },
    first_name () {
      // console.log(this.$store.getters.user)
      return !this.$store.getters.user ? false : this.$store.getters.user[0].first_name
    },
    last_name () {
      // console.log(this.$store.getters.user)
      return !this.$store.getters.user ? false : this.$store.getters.user[0].last_name
    }
  },
  methods:{
    ChangePassword(){
        //console.log(this.$store.getters.user[0].id)
        if(!this.error && this.success){
        const id=this.$store.getters.user[0].id
        //console.log(this.old_password)
        //console.log(this.password)
        //console.log(this.password2)
        const token = localStorage.getItem('token')


        axios.put('/change_password/'+id+'/', {
          password: this.password,
          password2: this.password2,
          old_password: this.old_password,
        },{ headers: { Authorization: `Bearer ${token}` } })
          .then(res=>{
            this.successAlert=true
            this.old_password=''
            this.password=''
            this.password2=''
            setTimeout(()=>this.successAlert=false,2000);
          }).catch(err => {
          this.alert=true
          this.old_password=''
          this.password=''
          this.password2=''
          setTimeout(()=>this.alert=false,2000);
          })
        }else{
          this.alert=true
          setTimeout(()=>this.alert=false,2000);
        }

    },
    UpdateUser(){
        const token = localStorage.getItem('token')
       // console.log(this.$store.getters.user[0].id)
        const id=this.$store.getters.user[0].id
        //console.log(this.username_new)
       // console.log(this.email_new)
        if(!this.username_new){
          this.username_new= this.username
        }
        if(!this.email_new){
          this.email_new=this.email
        }
       // console.log(this.username_new)
       // console.log(this.email_new)

        axios.put('/update_profile/'+id+'/', {
          username: this.username_new,
          email: this.email_new,
        },{ headers: { Authorization: `Bearer ${token}` } })
          .then(res=>{
            this.successAlert=true
            this.$store.getters.user[0].username=this.username_new
            this.$store.getters.user[0].email=this.email_new
            localStorage.setItem('username', this.username_new)
            setTimeout(()=>this.successAlert=false,2000);


          }).catch(err => {
          this.alert=true
          this.username_new =''
          this.email_new =''
          setTimeout(()=>this.alert=false,2000);
        })


    }
  }

}

</script>



<style>
.list-group-item.active {
  z-index: 2;
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.list-group-item-action:hover {
    color: #e92323 !important;
}
.red{
  color:rgb(255,0,0)!important
}
.green{
  color:#12a024!important
}

</style>
